/* eslint-disable max-len */
const React = require('react');

const PluginMagento = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="54" height="48" viewBox="0 0 54 48">
    <g fill="#F26322">
      <path d="M17.097 0L0 9.787 0 29.336 4.881 32.134 4.846 12.581 17.063 5.588 29.279 12.581 29.279 32.125 34.16 29.336 34.16 9.77z" transform="translate(9.5 4.5)" />
      <path d="M19.228 31.664L16.804 33.077 14.368 31.677 14.368 12.017 9.52 14.825 9.529 34.476 16.8 38.689 24.08 34.476 24.08 14.825 19.228 12.017z" transform="translate(9.5 4.5)" />
    </g>
  </svg>
);

module.exports = PluginMagento;
